/**
 * @generated SignedSource<<5b751598236bbbb57fbdeb8840bc2722>>
 * @lightSyntaxTransform
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InstitutionalAuthority_AddendumPage_Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AdditionalApplicant",
      "kind": "LinkedField",
      "name": "institutionalAuthority",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AccessRequestDraft",
  "abstractKey": null
};

node.hash = "8d6d2a6e120633f607d571f640b4f503";

export default node;
